import { Grid, Paper } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import {
  BASE_URL_VCLAIM,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance1,
  instance2,
  TYPE_INSTANCE1,
  V1,
} from "App/constants";
import { getUserName } from "App/utils/cookies";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import useMultipleSelect, {
  validasiMultipleSelect,
} from "hooks/useMultipleSelect";
import React, { useState } from "react";
import { LIST_URL_MASTER } from "utils/masters";
import { PilihDokter } from "../../../KunjunganRawatJalan/ui/TableListRencanaKontrol/FormRencanaKontrol";
import { RESET_STATE_SPRI } from "./helpers";

export function FormNoSPRI({
  noBpjs,
  formData,
  setFormData,
  handleTutupModalDanSetNoSpri,
  registrasiID = "",
}) {
  return (
    <Paper
      className='form-no-spri'
      style={{
        padding: "1rem",
      }}>
      <details id='summary-form-spri'>
        <summary>Buat Nomor SPRI</summary>

        <InputFormNoSPRI
          formData={formData}
          setFormData={setFormData}
          noBpjs={noBpjs}
          registrasiID={registrasiID}
          handleTutupModalDanSetNoSpri={handleTutupModalDanSetNoSpri}
        />
      </details>
    </Paper>
  );
}

export const InputFormNoSPRI = ({
  formData,
  setFormData,
  noBpjs,
  handleTutupModalDanSetNoSpri,
  registrasiID,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const multipleSelectData = useMultipleSelect([
    {
      url: LIST_URL_MASTER.spesialis.list,
      search: true,
      type_instance: TYPE_INSTANCE1,
      value: "codebridgepolibpjs",
      label: ["name"],
      type_response: "body",
      key: "spesialis",
    },
  ]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.nomor_spri)) {
        await createSpri();
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else {
        await updateSpri();
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      }
    } catch (error) {
      console.log(error);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    }
  };

  const createSpri = async () => {
    const response = await instance1.post(
      `/bridging`,
      {
        kode_dokter: formData.kode_dokter.toString(),
        poli_kontrol: formData.kode_poliklinik,
        nomor_kartu: noBpjs,
        tgl_rencana_kontrol: formData.tgl_rencana_kontrol,
        user: getUserName(),
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rencana-kontrol/insert-spri`,
        },
      }
    );

    if (parseInt(response.data?.body?.metaData.code) === 200) {
      const noSPRI = response.data.body.response.noSPRI;
      defaultToastSuccess("Success");
      handleTutupModalDanSetNoSpri(noSPRI);
      await updateSpriToEmr({
        no_spri: noSPRI,
        tgl_rencana_control: formData.tgl_rencana_control,
        bpjs_response: response.data.body.response,
      });
    } else {
      defaultToastError(response.data?.body?.metaData.message);
    }
  };

  const updateSpri = async () => {
    const response = await instance1.post(
      `/bridging`,
      {
        nomor_spri: formData.nomor_spri,
        kode_dokter: formData.kode_dokter.toString(),
        poli_kontrol: formData.kode_poliklinik,
        nomor_kartu: noBpjs,
        tgl_rencana_kontrol: formData.tgl_rencana_kontrol,
        user: getUserName(),
      },
      {
        headers: {
          method: "put",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rencana-kontrol/update-spri`,
        },
      }
    );

    if (parseInt(response.data?.body?.metaData.code) === 200) {
      defaultToastSuccess("Success");
      handleTutupModalDanSetNoSpri(response.data.body.response.noSPRI);
      await updateSpriToEmr({
        no_spri: formData.nomor_spri,
        tgl_rencana_control: formData.tgl_rencana_control,
        bpjs_response: response.data.body.response,
      });
    } else {
      defaultToastError(response.data?.body?.metaData.message);
    }
  };

  const updateSpriToEmr = async (data) => {
    try {
      if (!isNull(registrasiID)) {
        const response = await instance2.post(
          "/registration/registration/update-spri-rawatinap",
          {
            id_registrasi: registrasiID,
            no_spri: data.no_spri,
            tgl_rencana_control: data.tgl_rencana_kontrol,
            bpjs_response: data.bpjs_response,
          }
        );

        if (response.data.status === 200) {
          console.log("success update spri emr");
        } else {
          console.log("gagal update spri emr");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <Grid container spacing={1} className='form-no-spri'>
        <Grid item sm={3}>
          <InputTextMaster
            name='nomor_spri'
            label='NOMOR SPRI'
            disabled={true}
            readOnly={true}
            id='nomor_spri'
            value={formData.nomor_spri}
            onChange={handleChange("nomor_spri")}
            placeholder='Nomor SPRI'
          />
        </Grid>
        <Grid item sm={3}>
          <InputTextMaster
            name='nomor_kartu'
            label='NO BPJS'
            disabled={true}
            readOnly={true}
            id='nomor_kartu'
            value={noBpjs}
            onChange={handleChange("nomor_kartu")}
            placeholder='No BPJS'
          />
        </Grid>
        <Grid item sm={3}>
          <PilihDokter formData={formData} setFormData={setFormData} />
        </Grid>
        <Grid item sm={3}>
          <InputOptionMaster
            name='kode_poliklinik'
            label='POLIKLINIK'
            id='kode_poliklinik'
            withSearch={true}
            data={validasiMultipleSelect(multipleSelectData, 0)}
            value={formData.kode_poliklinik}
            labelValue={formData.nama_poliklinik}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  kode_poliklinik: null,
                  nama_poliklinik: "Pilih Poliklinik",
                });
              } else {
                setFormData({
                  ...formData,
                  kode_poliklinik: e.value,
                  nama_poliklinik: e.label,
                });
              }
            }}
          />
        </Grid>
        <Grid item sm={3}>
          <InputTextMaster
            name='tgl_rencana_kontrol'
            label='TGL RENCANA KONTROl'
            id='tgl_rencana_kontrol'
            type='date'
            value={formData.tgl_rencana_kontrol}
            onChange={handleChange("tgl_rencana_kontrol")}
            placeholder='Tgl Rencana Kontrol'
          />
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='button'
            color={"danger"}
            name={"RESET"}
            onClick={() => setFormData(RESET_STATE_SPRI)}
            size='md'
          />
          <MasterButton
            className={"mt-1"}
            type='button'
            onClick={(e) => handleSubmit(e)}
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default FormNoSPRI;
